module.exports = __webpack_public_path__ + "img/8008.ab3476f9.gif";